/* eslint-disable prettier/prettier */
import React from 'react';
import { Grid, Typography } from '@mui/material';

const RoundsDisplay = ({ rounds }) => (
    <>
        {rounds?.map((round) => (
            <Grid item ml={3} key={round.round_number}>
                <Grid justifyContent="center" alignItems="center">
                    <Typography variant="h6" color="primary.text" textAlign="center">
                        {`Round ${round?.round_number}`}
                    </Typography>
                    <Grid container>
                        {round.matches?.map((match, idx) => (
                            <Grid
                                key={idx}
                                ml={0.5}
                                sx={{
                                    width: 24,
                                    height: 12,
                                    backgroundColor: match.status === 'completed' ? 'green' : null,
                                    border: '0.5px solid green'
                                }}
                            />
                        ))}
                    </Grid>
                </Grid>
            </Grid>
        ))}
    </>
);

export default RoundsDisplay; 